// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".nav-input input {\n  padding-left: 50px !important;\n}", "",{"version":3,"sources":["/spug/spug_api/repos/119_10566_20260928180206/packages/kankan-laser/src/views/navigation/index.vue"],"names":[],"mappings":"AACA;EACE,6BAAA;AAAF","file":"index.vue","sourcesContent":["\n.nav-input input {\n  padding-left: 50px !important;\n}\n"]}]);
// Exports
module.exports = exports;
